import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { DefaultCollectContext } from '../..';

export const ModalRemoveInvoice = () => {
  const { Modal, closeModal } = useModal();

  const {
    fileAmount,
    invoiceFiles,
    setInvoiceFiles,
    removeInvoice,
    setRemoveInvoice,
    useForceUpdate,
    setDocumentType
  } = useContext(DefaultCollectContext);

  const forceUpdate = useForceUpdate();

  const handleRemove = () => {
    const indexFile = invoiceFiles.findIndex(
      (file) => file.id === removeInvoice
    );

    const newInvoiceFiles = invoiceFiles;

    newInvoiceFiles[indexFile] = {
      id: newInvoiceFiles[indexFile].id,
      file: '',
      name: '',
      size: '',
      readableSize: '',
      invoiceNumber: '',
      invoiceDate: ''
    };

    while (
      !!newInvoiceFiles?.find(({ file }) => file === '') &&
      newInvoiceFiles?.length > fileAmount
    ) {
      newInvoiceFiles?.reverse();

      const itemToRemove = newInvoiceFiles?.findIndex(
        ({ file }) => file === ''
      );

      if (itemToRemove >= 0) {
        newInvoiceFiles.splice(itemToRemove, 1);
      }

      newInvoiceFiles?.reverse();
    }

    setInvoiceFiles(newInvoiceFiles);

    !newInvoiceFiles?.find(({ file }) => file !== '') && setDocumentType('');

    forceUpdate();
    setRemoveInvoice('');
    closeModal();
  };

  return (
    <Modal>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}
      >
        <ModalTitle>Atenção</ModalTitle>

        <ModalText>
          Ao excluir o documento “Nota Fiscal”, um novo “Tipo de Documento
          Fiscal” deverá ser selecionado na solicitação. Deseja continuar?
        </ModalText>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32,
            marginTop: 16
          }}
        >
          <Button
            type="button"
            data-testid="rejectRemoveInvoiceFileModalButton"
            variant="contained"
            color="error"
            onClick={closeModal}
          >
            Não
          </Button>
          <Button
            type="button"
            data-testid="accepptRemoveInvoiceFileModalButton"
            variant="contained"
            onClick={handleRemove}
          >
            Sim
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
